import React from "react";

export default function DeviceKilledModal({ open, onConfirm }) {
  if (!open) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.badge}>NEO-APP</div>

        <h2 style={styles.title}>Device Unlinked</h2>

        <p style={styles.message}>
          This device has been unlinked by an administrator.
        </p>

        <button style={styles.button} onClick={onConfirm}>
          Continue
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(2, 6, 23, 0.72)",
    backdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 99999,
    padding: "20px",
  },
  modal: {
    width: "100%",
    maxWidth: "420px",
    borderRadius: "20px",
    background: "linear-gradient(180deg, #08162f 0%, #0b1f3f 100%)",
    border: "1px solid rgba(255,255,255,0.08)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.45)",
    padding: "24px",
    textAlign: "center",
    color: "#ffffff",
  },
  badge: {
    display: "inline-block",
    padding: "6px 12px",
    borderRadius: "999px",
    background: "rgba(59,130,246,0.16)",
    border: "1px solid rgba(96,165,250,0.35)",
    color: "#dbeafe",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    marginBottom: "16px",
  },
  title: {
    margin: "0 0 12px",
    fontSize: "30px",
    fontWeight: 800,
    lineHeight: 1.1,
  },
  message: {
    margin: "0 0 22px",
    fontSize: "15px",
    lineHeight: 1.5,
    color: "rgba(255,255,255,0.88)",
  },
  button: {
    width: "100%",
    border: 0,
    borderRadius: "14px",
    padding: "14px 18px",
    fontSize: "16px",
    fontWeight: 800,
    cursor: "pointer",
    color: "#04111d",
    background: "linear-gradient(90deg, #10b981 0%, #0ea5e9 100%)",
    boxShadow: "0 12px 30px rgba(0,0,0,0.28)",
  },
};